// @flow
import type { Lead } from 'types'
import { apiError, get, patch, post } from 'util/api'

export function fetchByFamily(familyId: number): Promise<Lead[]> {
  return get(`/api/leads?family_id=${familyId}`).then(response => response.json.leads)
}

export function create(schoolId: number, lead: $Shape<Lead>): Promise<Lead> {
  return post('/api/leads', { schoolId, lead })
    .then(response => response.json.lead)
    .catch(response => {
      throw apiError(response.json)
    })
}

export function update(id: number, lead: $Shape<Lead>): Promise<Lead> {
  return patch(`/api/leads/${id}`, { lead })
    .then(response => response.json.lead)
    .catch(response => {
      throw apiError(response.json)
    })
}
